import {useMutation, useQueryClient} from '@tanstack/react-query';
import {useSnackbar} from 'notistack';

import {unbanUser} from '../api';
import {QUERY__USER_BANS, QUERY__USERS} from '../queryKeys';

export const useUnbanUser = () => {
  const queryClient = useQueryClient();
  const {enqueueSnackbar} = useSnackbar();
  return useMutation({
    mutationFn: (params: string) => unbanUser(params),
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries({queryKey: [QUERY__USERS]}),
        queryClient.invalidateQueries({queryKey: [QUERY__USER_BANS]}),
      ]),
    onError: error => {
      enqueueSnackbar(error.message, {variant: 'error'});
    },
  });
};
